import axios from 'axios'
import appConfig from 'configs/app.config'
import { TOKEN_TYPE, REQUEST_HEADER_AUTH_KEY } from 'constants/api.constant'
import store from '../store'
import { onSignOutSuccess } from '../store/auth/sessionSlice'
import { env } from 'configs/EnvironmentConfig';
import { AUTH_CONSTANT } from 'constants/AuthConstant'
import { API_BASE_URL } from 'configs/app.config'
import ServiceUtils from 'utils/ServiceUtils'

const unauthorizedCode = [401, 403]

const BaseService = axios.create({
    timeout: 60000,
    baseURL: env.API_ENDPOINT_URL + appConfig.apiPrefix,
})

BaseService.interceptors.request.use(
    async config => {
        const jwt = sessionStorage.getItem(AUTH_CONSTANT.JWT)
        if (jwt) {
            const jwtObject = JSON.parse(jwt)
            const accessToken = jwtObject.accessToken
            const rTtimeLeft = jwtObject.expireAt - Date.now();
            console.log("refreshToken 현재남은시간 =" + rTtimeLeft);

            if (jwtObject.expireAt < Date.now()) {
                console.log("refreshToken 만료됨.")
                sessionStorage.removeItem(AUTH_CONSTANT.JWT)
            } else {
                const timeLeft = jwtObject.accessExpireAt - Date.now();
                console.log("accessToken 현재남은시간 =" + timeLeft);

                if (timeLeft < 10000) {
                    console.log("accessToken 만료 도래하여 refresh.")

                    const { data } = await axios.post(`${API_BASE_URL}/adm/v1/auth/refresh`, { token: jwtObject.refreshToken });
                    if (ServiceUtils.checkResult(data.header)) {
                        console.log("accessToken refresh 성공.");
                        console.log(JSON.stringify(data.jwt));
                        jwtObject.accessToken = data.jwt.accessToken;
                        jwtObject.accessExpireAt = data.jwt.accessExpireAt;

                        sessionStorage.setItem(AUTH_CONSTANT.JWT, JSON.stringify(jwtObject));
                        config.headers[REQUEST_HEADER_AUTH_KEY] = `${TOKEN_TYPE}${jwtObject.accessToken}`
                    } else {
                        console.log("accessToken refresh 실패.")
                        sessionStorage.removeItem(AUTH_CONSTANT.JWT)
                        localStorage.removeItem(AUTH_CONSTANT.JWT)
                    }
                } else if (accessToken) {
                    config.headers[REQUEST_HEADER_AUTH_KEY] = `${TOKEN_TYPE}${accessToken}`
                }
            }
        }
        return config
    },
    (error) => {
        
        return Promise.reject(error)
    }
)

BaseService.interceptors.response.use(
    (response) => response,
    (error) => {
        const { response } = error
        
        if (response && unauthorizedCode.includes(response.status)) {
            store.dispatch(onSignOutSuccess())
        }

        return Promise.reject(error)
    }
)

export default BaseService
